<template>
    <div>
        <el-dialog title="反馈信息" width: :visible.sync="commentflag" width="950px">
            <el-card class="box-card" style="margin-bottom:15px;padding-left:10px;padding-right:10px;">
                <div style="margin-bottom:8px;">
                    <el-row>
                        <el-col :span="12">
                            反馈人：{{infodata.userName}}
                        </el-col>
                        <el-col :span="12">
                            反馈时间：{{times(infodata.createTime)}}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col  :xs="6" :sm="4" :md="4" :lg="3">
                                工作内容：
                        </el-col>
                        <el-col :xs="18" :sm="20" :md="20" :lg="21">
                            <div v-for="(content,index) in infodata.projectContents" :key="index">{{content.tips}}</div>
                        </el-col>
                    </el-row>
                    <img style="position: absolute;right: 50px;top: 40px;z-index:999"  :src="infodata.flag==1?'/img/resolved.png':'/img/unresolved.png'" width="180px"/>
                    <el-row>
                        <el-col :span="24">
                                反馈内容：{{infodata.tips.split('times=')[0]}}
                        </el-col>
                    </el-row>
                    <el-row v-if="imgPathlist">
                        <el-col  :xs="6" :sm="4" :md="4" :lg="3">
                                反馈图片：
                        </el-col>
                        <el-col :xs="18" :sm="20" :md="20" :lg="21">
                            <img  v-for="(item,index) in imgPathlist" :key=index :src="getimgpath(item)" preview="1" style="width:178px;height:178px;margin-right:10px;"/>
                        </el-col>
                    </el-row>
                    <el-row v-if="videoPathlist">
                        <el-col  :xs="6" :sm="4" :md="4" :lg="3">
                                反馈视频：
                        </el-col>
                        <el-col :xs="18" :sm="20" :md="20" :lg="21">
                            <video v-for="(item,index) in videoPathlist" :key=index  :src="getimgpath(item)" controls="controls" style="width: 49%;height:150px;float:left;margin-right:1%;"> </video>
                        </el-col>
                    </el-row>
                    <el-row> 
                        <el-col :span="24">
                            <p>查看过{{infodata.projectFeedbackLogs.length}}人</p>
                            <div v-for="(item,index) in infodata.projectFeedbackLogs" :key=index >
                                <div v-if="item.operation==1" style="width:auto;float:left;margin-right:15px;margin-bottom:15px;text-align:center;">
                                    <el-row>
                                        <img :src="item.avatar?getimgpath(item.avatar):(item.headimgurl?item.headimgurl:'/img/default-avatar.png')" style="width:60px;border-radius:50%;text-align:center;"/>
                                    </el-row>
                                    <el-row>
                                        <el-tag style="margin-top:10px;font-size:10px;">{{item.userName}}</el-tag>
                                    </el-row>
                                </div>
                                
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
            <el-card class="box-card" v-if="record.length==0" style="margin-bottom:15px;">
                <p style="margin-bottom:8px;margin-left:15px;">暂时没有评论信息</p>
            </el-card>
            <div v-for="(item,index) in record" :key=index class="text item">
                <el-card class="box-card" style="margin-bottom:15px;">
                    <div style="margin-bottom:8px;">
                        <el-row style="margin:0 15px;">
                                <el-col :span="3">
                                    <img :src="item.avatar?getimgpath(item.avatar):(item.headimgurl?item.headimgurl:'/img/default-avatar.png')" style="width:60px;border-radius:50%;"/>
                                </el-col>
                                <el-col :span="21">
                                    <el-row>
                                        <el-col :span="24">
                                            <span>{{item.userName?item.userName:''}}</span> 
                                            <span style="margin-left:20px;">{{times(item.createTime)}}</span> 
                                        </el-col>
                                        <el-col :span="24" >
                                            {{item.content}}
                                        </el-col>
                                    </el-row>
                                </el-col>
                        </el-row>
                    </div>
                </el-card>
            </div>
            <el-form :model="form" ref="form" label-width="100" class="demo-dynamic" hide-required-asterisk>
                <el-form-item prop="content" label="评论" :rules="[{ required: true, message: '请输入评论信息', trigger: 'blur' }]" style="margin-bottom:0;">
                    <el-input v-model="form.content"></el-input>
                </el-form-item>
            </el-form>
             <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('form')">关闭</el-button>
                <el-button type="primary" @click="commentput('form')">评论</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {getComment,insertComment,getrecordinfo} from '@/api/admin/taskManagement'
    import { objKeySort } from '@/util/ajaxsign'
    import { dateOnce } from '@/util/dateT'
    import {getImgLink,getImgLinksplit} from '@/config/env'
    export default {
        components: {},
        data() {
            return {
                commentflag : false,
                serviceType : '',
                serviceId : '',
                infodata : undefined,
                radiorecord : '',
                record : [],
                imgPathlist : [],
                videoPathlist : [],
                state : '',
                form : {
                    content : ''
                }
            }
        },
        created() {},

        methods: {
            //设置展示
             commentstate(serviceId,serviceType,state){
                this.serviceType = 2;
                this.serviceId = serviceId;
                this.state = state;
                this.commentflag = true;
                this.getcomment();
                this.getrecordinfo();
                this.$previewRefresh();
            },
            getcomment(){
                getComment(objKeySort({serviceType:this.serviceType,serviceId:this.serviceId})).then(response =>{
                    this.record = response.data.data;
                })
            },
            getrecordinfo(){
                getrecordinfo(objKeySort({id:this.serviceId})).then(response =>{
                    this.infodata = response.data.data;
                    this.imgPathlist = response.data.data.imgPaths?response.data.data.imgPaths.split(','):[];
                    this.videoPathlist = response.data.data.voicePaths?response.data.data.voicePaths.split(','):[];
                    console.log(this.videoPathlist);
                })
            },
            //时间转化
            times(data){
                return dateOnce(data)
            },

            //发布评论
            commentput(data){
                console.log(data)
                this.$refs[data].validate((valid) => {
                if (valid) {
                    insertComment(objKeySort({serviceType:this.serviceType,serviceId:this.serviceId,content:this.form.content})).then(response =>{
                        this.getcomment();
                        this.$refs[data].resetFields();
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },

            //图片路径处理
            getimgpath(data){
                return getImgLink(data)
            },

            resetForm(data) {
                this.$refs[data].resetFields();
                this.commentflag = false;
            }

        }
    }
</script>
